
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "jst/_grading_box";
import "i18n!set_default_grade_dialog";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'SetDefaultGradeDialog';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function", self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'assignment.name': (((stack1 = (depth0 && depth0.assignment)),stack1 == null || stack1 === false ? stack1 : stack1.name)),
    'w0': ("<b>$1</b>"),
    'w1': ("<i>$1</i>"),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "give_all_students_the_same_percent_grade_for_assig_6a008004", "Give all students the same *percent* grade for **%{assignment.name}** by entering and submitting a grade value below:", options) : helperMissing.call(depth0, "t", "give_all_students_the_same_percent_grade_for_assig_6a008004", "Give all students the same *percent* grade for **%{assignment.name}** by entering and submitting a grade value below:", options)))
    + "\n      ";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'assignment.name': (((stack1 = (depth0 && depth0.assignment)),stack1 == null || stack1 === false ? stack1 : stack1.name)),
    'w0': ("<i>$1</i>"),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "give_all_students_the_same_grade_for_assignment_na_e44fcc7e", "Give all students the same grade for *%{assignment.name}* by entering and submitting a grade value below:", options) : helperMissing.call(depth0, "t", "give_all_students_the_same_grade_for_assignment_na_e44fcc7e", "Give all students the same grade for *%{assignment.name}* by entering and submitting a grade value below:", options)))
    + "\n      ";
  return buffer;
  }

  buffer += "<form id=\"set_default_grade_form\" action=\"";
  if (helper = helpers.url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" method=\"POST\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'assignment.name': (((stack1 = (depth0 && depth0.assignment)),stack1 == null || stack1 === false ? stack1 : stack1.name)),
    'scope': ("set_default_grade_dialog")
  },data:data},helper ? helper.call(depth0, "dialog_title", "Default grade for %{assignment.name}", options) : helperMissing.call(depth0, "t", "dialog_title", "Default grade for %{assignment.name}", options)))
    + "\">\n  <input type=\"hidden\" name=\"assignment_id\" class=\"assignment_id\" value=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.assignment)),stack1 == null || stack1 === false ? stack1 : stack1.id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\"/>\n  <div id=\"default_grade_description\">\n    <p>\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.assignment_grading_type_is_percent), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </p>\n  </div>\n  <div style=\"text-align: center;\" class=\"grading_box_holder\">\n    ";
  stack1 = self.invokePartial(partials.grading_box, 'grading_box', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n  <div>\n    <input type=\"checkbox\" name=\"overwrite_existing_grades\" id=\"overwrite_existing_grades_for_"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.assignment)),stack1 == null || stack1 === false ? stack1 : stack1.id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\"/>\n    <label for=\"overwrite_existing_grades_for_"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.assignment)),stack1 == null || stack1 === false ? stack1 : stack1.id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("set_default_grade_dialog")
  },data:data},helper ? helper.call(depth0, "overwrite", "Overwrite already-entered grades", options) : helperMissing.call(depth0, "t", "overwrite", "Overwrite already-entered grades", options)))
    + "</label>\n  </div>\n  <button type=\"submit\" class=\"btn\" data-text-while-loading=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("set_default_grade_dialog")
  },data:data},helper ? helper.call(depth0, "set_grades_button_loading", "Setting Grades...", options) : helperMissing.call(depth0, "t", "set_grades_button_loading", "Setting Grades...", options)))
    + "\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("set_default_grade_dialog")
  },data:data},helper ? helper.call(depth0, "set_grades_button", "Set Default Grade", options) : helperMissing.call(depth0, "t", "set_grades_button", "Set Default Grade", options)))
    + "</button>\n</form>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  